// Smartlink flow using the smartlink CDN script content
import React, {Component} from 'react';
import axios from "axios";

export default class Smartlink extends Component {
    state = {
        sessionId: '',
    };

    /*===FUNCTIONS THE CLIENT SHOULD HANDLE===*/
    fetchSessionId = () => {
        const {env} = this.props;
        axios.get(`/api/smartlink/session/${this.props.env}`, {
            params: {
                userId: "asd",
                username: "asd",
                phone: "+11234561234",
            }
        }).then(response => {
            this.setState({sessionId: response.data["session_token"]});
            // After getting sessionId initialize the component
            const sessionId = response.data["session_token"];
            const script = document.createElement('script');
            script.src = 'http://localhost:3000/scripts/smartlink.js'; // script url in smartlink repo
            script.onload = async () => {
                // call insertIframe onload
                window.Smartlink.insertIframe({sessionId});
            };
            script.onload = async () => {
                window.Smartlink.insertIframe({
                    sessionId: this.state.sessionId,
                    onInstitutionSelected: this.fetchLinkToken, // fetchLinkToken must be defined by client
                    onSuccess: this.onSuccess // fetchLinkToken must be defined by client
                });
            };
            document.body.appendChild(script);
        }).catch(error => {
            console.error("Error fetching sessionId:", error);
            this.setState({sessionId: ""});
        });
    };

    onSuccess = (encryptedToken)=>{
        console.log('=======success connection, token: ========', encryptedToken)
    }

    fetchLinkToken = (institutionId) => {
        const {env} = this.props;
        const {sessionId} = this.state;
        axios.get(`/api/smartlink/link/${env}`, {
            params: {
                sessionToken: sessionId,
                institutionId: institutionId
            }
        }).then(response => {
            if (window.Smartlink && typeof window.Smartlink.sendLinkToken === "function") {
                window.Smartlink.sendLinkToken(response.data);
            } else {
                console.error("Smartlink script not loaded or sendLinkToken function not available.");
            }
        }).catch(error => {
            console.error("Error getting link token:", error);
        });
    };


    componentDidMount() {
        this.fetchSessionId();
    }

    render() {
        const {sessionId} = this.state;
        if (sessionId !== "")
            return <div id="smartlink" style={{height: '600px'}}></div>;
        else
            return <div>Loading smartlink</div>
    }
}
